import { useEffect } from "react";

const GFM_SCRIPT_SRC = "https://www.gofundme.com/static/js/embed.js";
const GFM_WIDGET_URL = "https://www.gofundme.com/f/humiliate-the-luce-and-launch-the-analog-revolution/widget/large?attribution_id=sl%3A755581a7-8d4e-4dfc-b0dd-5bc4a3503796";

export const GoFundMeWidget = () => {
  useEffect(() => {
    // Inject the GoFundMe embed script once. Leave it in the DOM so subsequent
    // renders find the existing tag and GoFundMe can hydrate the mount point.
    if (document.querySelector(`script[src="${GFM_SCRIPT_SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = GFM_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div
      className="gfm-embed"
      data-url={GFM_WIDGET_URL}
      data-testid="gofundme-widget"
    />
  );
};
